import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";
import { useLoginContext } from "../../Contexts/LoginContext";
import CustomerService from "../../Services/CustomerService";
import { useOrderTypeContext } from "../../Contexts/OrderTypeContext";
import { ImSpinner8 } from "react-icons/im";
import { TbClock, TbMoodConfuzed } from "react-icons/tb";
import { formatCartId } from "../../Utils/Formatters";
import Badge from "../../Components/Layout/Badge";
import Drawer from "../../Components/Layout/Drawer";
import OrderDetails from "../../Components/Layout/Checkout/OrderDetails";
import { getOrderColorByStatusId } from "../../Utils/Constants/Order";
import CardProfileOrder from "../../Components/Layout/Profile/CardProfileOrder";
import { ORDER_STATUS_AWAITING_PAYMENT, ORDER_STATUS_MOUNTING, ORDER_STATUS_OPEN, ORDER_STATUS_PENDING, ORDER_STATUS_RELEASED_SHIPMENT, ORDER_STATUS_RELEASED_TAKEAWAY, ORDER_STATUS_RETURNED } from "../../Utils/Constants/Checkout";
import OrderService from "../../Services/OrderService";
import { useLayoutContext } from "../../Contexts/LayoutContext";
import { useNavigate } from "react-router-dom";
import ButtonLink from "../../Components/Form/ButtonLink";
import { useStoreHook } from "../../Hooks/StoreHook";

const ProfileOrders = () => {
    const { currentStore } = useStoreContext();
    const { user, token } = useLoginContext();
    const { orderType } = useOrderTypeContext();
    const [showOrderDetail, setShowOrderDetail] = useState(false);
    const [currentOrder, setCurrentOrder] = useState<any>(null);
    const [ loadingOrders, setLoadingOrders ] = useState(false);
    const [currentCartId, setCurrentCartId] = useState<any>(null);
    const [ ordersList, setOrdersList ] = useState<[]>([]);
    const { getLinkToHome } = useStoreHook();
    const [loadingOrderDetail, setLoadingOrderDetail] = useState(false);
    const { setMainLoading, setMainLoadingIcon, setMainLoadingIconError, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton } = useLayoutContext();
    const navigate = useNavigate();
    document.title = 'Pedidos';

    const getOrders = async () => {
        setLoadingOrders(true);
        const payload = {
            user_id: user.id,
        }
        try {
            const customerService = new CustomerService(orderType, token);
            const response = await customerService.getCustomerOrders(payload);
            if (response) {
                setOrdersList(response);
            }
        setLoadingOrders(false);
        } catch (error: any) {
            setLoadingOrders(false);
        }
    }

    useEffect(() => {
        getOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getDetail = async (order_id: number) => {
        const payload = {
            order_id: order_id,
        }
        setShowOrderDetail(true);
        setLoadingOrderDetail(true);
        try {
            const orderService = new OrderService(orderType, token);
            const details = await orderService.detail(payload);

            if (details) {
                setCurrentOrder(details);
            }
        } catch (error) {
            console.error('Error orderDetail:', error);
            setShowOrderDetail(false);
            setLoadingOrderDetail(false);

            setMainLoading(true);
            setMainLoadingIcon(false);
            setMainLoadingIconError(true);
            setMainLoadingTitle('Ops! Algo não deu certo.');
            setMainLoadingMessage('Tente novamente em alguns instantes.');
            setMainLoadingCloseButton(true);
        } finally {
            setLoadingOrderDetail(false);
        }
    }

    const goToOrderPlace = (order_id: number) => {
        navigate(`${getLinkToHome()}/order/${order_id}/placed`);
        return;
    }

    const handleGetDetail = (orderToDetail: any) => {
        setCurrentCartId(orderToDetail.id);
        if (
                Number(orderToDetail.status) === ORDER_STATUS_AWAITING_PAYMENT ||
                Number(orderToDetail.status) === ORDER_STATUS_MOUNTING ||
                Number(orderToDetail.status) === ORDER_STATUS_OPEN ||
                Number(orderToDetail.status) === ORDER_STATUS_PENDING ||
                Number(orderToDetail.status) === ORDER_STATUS_RELEASED_SHIPMENT ||
                Number(orderToDetail.status) === ORDER_STATUS_RELEASED_TAKEAWAY ||
                Number(orderToDetail.status) === ORDER_STATUS_RETURNED
        ) {
            goToOrderPlace(orderToDetail.id);
        }
        getDetail(orderToDetail.id);
    }

    return (
        <>
            <DefaultLayout showHeader={currentStore}>
                <DefaultLayoutProfile>
                    <div className="flex flex-col gap-4 p-2">
                        <h4 className="flex items-center justify-between text-xl font-extrabold text-custom-primary">Seus pedidos</h4>
                        <div className="flex items-center justify-between text-xs text-gray-400 gap-4">
                            <span className="text-nowrap leading-none">
                                {loadingOrders 
                                    ? <span className="flex items-center gap-1"><ImSpinner8 className="animate-spin" />Carregando pedidos</span>
                                    : ordersList.length === 0 ? 'Nenhum pedido encontrado' : ordersList.length > 1 ? `${ordersList.length} pedidos encontrados` : `${ordersList.length} pedido encontrado`
                                }
                            </span>
                            <hr className="opacity-25 w-full" />
                            <ButtonLink onClick={() => getOrders()} disabled={loadingOrders} outline className="text-xs gap-1 h-8">
                                {loadingOrders && <span><ImSpinner8 className="animate-spin" /></span>}
                                <span>{loadingOrders ? 'Aguarde' : 'Atualizar'}</span>
                            </ButtonLink>
                        </div>
                        <div className={`${loadingOrders && 'opacity-50'} transition-all ease-in-out`}>
                            {!loadingOrders && ordersList.length === 0
                                ? <div className='flex items-center gap-1 text-sm text-gray-500'><TbMoodConfuzed /> <span>Nenhum pedido encontrado</span></div>
                                : <div className='grid text-sm divide-y rounded-none divide-gray-100'>
                                    {
                                        ordersList.map((order: any, index: number) => (
                                            <CardProfileOrder order={order} onClick={() => handleGetDetail(order)} key={index} />
                                        ))
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </DefaultLayoutProfile>
            </DefaultLayout>

            <Drawer open={showOrderDetail}
                title={`Pedido ${formatCartId(currentCartId)}`}
                subtitle={
                    loadingOrderDetail
                        ?
                            <div className="flex gap-1 animate-pulse">
                                <div className="bg-gray-200 h-5 w-20 rounded"></div>
                                <div className="bg-gray-200 h-5 w-28 rounded"></div>
                            </div>
                        : currentOrder &&
                            <div className='flex items-center gap-1'>
                                <Badge type={getOrderColorByStatusId(currentOrder.status)} className="text-xs">{ currentOrder.status_name }</Badge>
                                <Badge className="text-xs gap-0.5 capitalize text-normal pl-1"><TbClock /><span>{currentOrder.created_at_formatted}</span></Badge>
                            </div>
                }
                fromBottom={false}
                onClose={() => setShowOrderDetail(false)}
                >
                    <OrderDetails order={currentOrder} loading={loadingOrderDetail} onClose={() => setShowOrderDetail(false)} />
            </Drawer>
        </>
    );
};

export default ProfileOrders;